import objectKeys from "./objectKeys";

const makeUrlQuery = (parts: Record<string, string>): string => {
  const query = new URLSearchParams();
  objectKeys(parts).forEach(key => {
    query.set(key, encodeURIComponent(parts[key]));
  });


  return query.toString();
};

export default makeUrlQuery;
